import { Typography, Flex } from 'antd';
import React from 'react';
import { mdiOpenInNew, mdiContentCopy } from '@mdi/js';
import TableIcons from 'components/table-formatters/TableIcons/TableIcons';
import copyToClipboard from 'common/utils/copyToClipboard';
import Ninja from '@ninja';

const removeHttps = (url) => url?.replace(/^https?:\/\//, '');

const JourneyUrlFormatter = ({ url, disableCopy = false, className, width }) => {
  const { Link } = Typography;

  const handleOpenUrl = () => {
    const finalUrl = url.startsWith('http') ? url : `https://${url}`;
    window.open(finalUrl, '_blank');
  };

  const copyName = () => {
    copyToClipboard(url);
  };

  return (
    <Flex
      align='center'
      gap='small'
      className={`icons-hover-trigger w-full max-w-64  ${className}`}
    >
      <TableIcons
        color={Ninja.colors.blue}
        icons={[
          {
            onlyOnHover: true,
            icon: mdiContentCopy,
            tooltip: 'Copy',
            size: 0.6,
            onClick: copyName,
            show: !disableCopy,
          },
          {
            icon: mdiOpenInNew,
            tooltip: 'Open URL',
            size: 0.6,
            onClick: handleOpenUrl,
          },
        ]}
      />
      <Link
        href={url}
        target='_blank'
        className='overflow-hidden whitespace-nowrap text-ellipsis inline-block !text-xs font-medium text-left mr-1 '
        style={{ width: typeof width === 'number' ? `${width}px` : width }}
      >
        {removeHttps(url)}
      </Link>
    </Flex>
  );
};

export default JourneyUrlFormatter;
